<mat-card appearance="outlined" class="special-features__subsection subsection">
  <div class="subsection__header">
    <span class="subsection__header-item header-item header--title"
      ><h4>{{ title }}</h4></span
    >
    <span class="subsection__header-item header-item header-item--download">
      <mat-icon
        class="pointer"
        (click)="onDownloadClick()"
        matTooltip="Download Report"
        matTooltipClass="pdq-mat-tooltip"
        matTooltipPosition="above"
        >system_update_alt</mat-icon
      >
    </span>
    @if (value$ | async) {
      <span class="subsection__header-item header-item header-item--number">
        <h4>{{ value$ | async }}</h4>
      </span>
    }
  </div>
</mat-card>
